import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/lang";
import { api, useAuth } from "@/lib/auth";
import { ScrollText } from "lucide-react";

// Blocking gate shown right after login until the user accepts the current
// version of the Terms/Privacy (TERMS_VERSION on the backend). Unlike the
// camera-consent modal, there's no "continue without accepting" option —
// clause 1 of the Terms is explicit that using the Service requires
// acceptance, so declining logs the user out instead.
export default function TermsGateModal() {
    const { t } = useLang();
    const { refresh, logout } = useAuth();
    const [loading, setLoading] = useState(false);

    const accept = async () => {
        setLoading(true);
        try {
            await api.post("/auth/accept-terms");
            await refresh();
        } catch (e) {
            // non-fatal — leave the gate up so the user can retry
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-6" data-testid="terms-gate-modal">
            <div className="bg-white max-w-md w-full rounded-lg border border-slate-200 p-8">
                <div className="w-14 h-14 rounded-full bg-brand/10 flex items-center justify-center mb-6">
                    <ScrollText size={26} className="text-brand" />
                </div>
                <h2 className="font-display text-2xl mb-3 tracking-tight" data-testid="terms-gate-title">
                    {t("terms_gate.title")}
                </h2>
                <p className="text-sm text-slate-600 leading-relaxed mb-6">
                    {t("terms_gate.body")}{" "}
                    <Link to="/terms" target="_blank" className="text-brand hover:underline">
                        {t("terms_gate.terms_link")}
                    </Link>{" "}
                    {t("terms_gate.and")}{" "}
                    <Link to="/privacy" target="_blank" className="text-brand hover:underline">
                        {t("terms_gate.privacy_link")}
                    </Link>.
                </p>
                <div className="flex flex-col gap-2">
                    <button onClick={accept} disabled={loading} className="btn-primary w-full justify-center" data-testid="terms-gate-accept-btn">
                        {t("terms_gate.accept")}
                    </button>
                    <button onClick={logout} className="btn-ghost w-full justify-center text-sm" data-testid="terms-gate-decline-btn">
                        {t("terms_gate.decline")}
                    </button>
                </div>
            </div>
        </div>
    );
}
